<template>
  <div class="col" style="margin-top: 150px">
    <div v-if="producers && producers.length > 0" class="cmpn-card-container">
      <b-card
        v-for="(producer, i) in producers"
        :key="i"
        class="mv-card cmpn-card-item"
        header-class="text-center font-size: 24px;">
        <template v-slot:header>
          <glcwc-content-image-only :content-key="producer.imgSrc" img-align="center"></glcwc-content-image-only>
          <!-- <i class="mdi mdi-factory" style="font-size: 32px;"></i> -->
          <b-icon icon="gear" style="font-size: 32px;"></b-icon>
        </template>
        <h4>
          <glcwc-content-text-only :content-key="producer.name"></glcwc-content-text-only>
        </h4>
        <h6 class="card-subtitle text-muted mb-2">
          <glcwc-content-text-only :content-key="producer.header"></glcwc-content-text-only>
        </h6>
        <h6>
          <glcwc-content-text-only :content-key="producer.info"></glcwc-content-text-only>
        </h6>
        <!-- <b-modal
          :id="'modal-producer-' + i"
          :title="producer.name"
          ok-only
          hide-footer>
          {{ producer.info }}
        </b-modal> -->
        <template v-slot:footer>
          <center>
            <b-button v-b-modal="'modal-producer-' + i">Mehr lesen</b-button>
          </center>
        </template>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Producers',
  data () {
    return {
      producers: []
    }
  }, // data
  async created () {
    /* eslint quote-props: ["error", "as-needed", { "unnecessary": false }] */
    this.$tracker('event', 'screen_view', {
      'app_name': 'magiv',
      'screen_name': 'Producers'
    })
    try {
      this.producers = (await import('./data/producers')).default.list
    } catch (e) {
      // TODO display some error
      console.log('TRACE-REMOVE: exception is: ', e)
    } finally {

    }
  } // created
}
</script>

<style scoped>
.cmpn-card-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  padding: 1px;
  /*margin: -10px;*/
  min-width: 200px;
  /*border: solid;
  border-color: black;*/
}
.cmpn-card-item {
  display: flex;
  flex: 1 0 auto;
  /*flex-basis: 200px;*/
  margin: 1px;
  min-width: 200px;
  max-width: 400px;
  width: 30%;
  /*border: solid;
  border-color: green;*/
}
</style>
